var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import { STATUS_MAP, INVOICE_STATUS_MAP, FILE_ICONS, formatMoney, formatDate, } from '@/assets/data/data';
import { createProject, updateProject, deleteProject, createInvoice, updateInvoice, deleteInvoice, uploadFile, downloadFile, deleteFile, getOrCreatePortalToken, deactivatePortalToken, sendNotification } from '@/lib/api';
import { supabase } from '@/lib/supabase';
import { PortalPreview } from '@/pages/portalPreview/PortalPreview';
import { ProjectModal } from '@/components/modal/ProjectModal';
import { InvoiceModal } from '@/components/modal/InvoiceModal';
import { BrandingSettings } from '@/components/branding/BrandingSettings';
import { NotificationSettings } from '@/components/notifications/NotificationSettings';
import { TimeTab } from '@/components/timeTracking/TimeTab';
import { useI18n } from '@/lib/i18n';
import * as styles from './ClientDetail.module.scss';
var KANBAN_COLS = ['brief', 'in_progress', 'review', 'done'];
export var ClientDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var client = _a.client, onEditClient = _a.onEditClient, onClientUpdated = _a.onClientUpdated, _l = _a.isPro, isPro = _l === void 0 ? false : _l, onUpgrade = _a.onUpgrade, onDataChanged = _a.onDataChanged, timerState = _a.timerState;
    var t = useI18n().t;
    var TABS = [
        { key: 'projects', label: t.tabProjects, icon: '📋' },
        { key: 'invoices', label: t.tabInvoices, icon: '💳' },
        { key: 'files', label: t.tabFiles, icon: '📁' },
        { key: 'time', label: t.tabTime, icon: '⏱️' },
        { key: 'portal', label: t.tabPortal, icon: '🔗' },
    ];
    var _m = useState('projects'), tab = _m[0], setTab = _m[1];
    var _o = useState(false), showPortal = _o[0], setShowPortal = _o[1];
    var _p = useState(false), showProjectModal = _p[0], setShowProjectModal = _p[1];
    var _q = useState(null), editingProject = _q[0], setEditingProject = _q[1];
    var _r = useState(false), showInvoiceModal = _r[0], setShowInvoiceModal = _r[1];
    var _s = useState(null), editingInvoice = _s[0], setEditingInvoice = _s[1];
    var _t = useState(client.projects), projects = _t[0], setProjects = _t[1];
    var _u = useState(client.invoices), invoices = _u[0], setInvoices = _u[1];
    var _v = useState(client.files), files = _v[0], setFiles = _v[1];
    // Set default timer project when client changes
    React.useEffect(function () {
        setProjects(client.projects);
        setInvoices(client.invoices);
        setFiles(client.files);
        setTab('projects');
        if (timerState && !timerState.timerRunning && client.projects[0]) {
            timerState.onTimerProjectChange(client.projects[0].id);
        }
    }, [client.id]);
    var handleUploadFiles = function (fileList) { return __awaiter(void 0, void 0, void 0, function () {
        var _loop_1, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _loop_1 = function (i) {
                        var created_1, err_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, uploadFile(client.id, fileList[i])];
                                case 1:
                                    created_1 = _b.sent();
                                    setFiles(function (prev) { return __spreadArray(__spreadArray([], prev, true), [created_1], false); });
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_1 = _b.sent();
                                    console.error('Failed to upload file:', err_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < fileList.length)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(i)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDownloadFile = function (f) { return __awaiter(void 0, void 0, void 0, function () {
        var url, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!f.storagePath)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, downloadFile(f.storagePath)];
                case 2:
                    url = _a.sent();
                    window.open(url, '_blank');
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error('Failed to download file:', err_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteFile = function (f) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!f.storagePath)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteFile(f.id, f.storagePath)];
                case 2:
                    _a.sent();
                    setFiles(function (prev) { return prev.filter(function (file) { return file.id !== f.id; }); });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    return [3 /*break*/, 4];
                case 3:
                    err_3 = _a.sent();
                    console.error('Failed to delete file:', err_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCreateProject = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var created_2, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createProject({
                            clientId: data.clientId,
                            name: data.name,
                            status: data.status,
                            progress: data.progress,
                            deadline: data.deadline,
                            description: data.description,
                            priority: data.priority,
                        })];
                case 1:
                    created_2 = _a.sent();
                    setProjects(function (prev) { return __spreadArray(__spreadArray([], prev, true), [created_2], false); });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    sendNotification({ type: 'project_created', clientId: client.id, projectName: data.name });
                    return [3 /*break*/, 3];
                case 2:
                    err_4 = _a.sent();
                    console.error('Failed to create project:', err_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateProject = function (projectId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var oldProject, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    oldProject = projects.find(function (p) { return p.id === projectId; });
                    return [4 /*yield*/, updateProject(projectId, data)];
                case 1:
                    _a.sent();
                    setProjects(function (prev) {
                        return prev.map(function (p) {
                            var _a, _b;
                            if (p.id !== projectId)
                                return p;
                            return __assign(__assign({}, p), { name: data.name, status: data.status, progress: data.progress, deadline: data.deadline, description: (_a = data.description) !== null && _a !== void 0 ? _a : p.description, priority: ((_b = data.priority) !== null && _b !== void 0 ? _b : p.priority) });
                        });
                    });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    if (oldProject && oldProject.status !== data.status) {
                        sendNotification({ type: 'project_status', clientId: client.id, projectName: data.name, newStatus: data.status });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_5 = _a.sent();
                    console.error('Failed to update project:', err_5);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteProject = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteProject(projectId)];
                case 1:
                    _a.sent();
                    setProjects(function (prev) { return prev.filter(function (p) { return p.id !== projectId; }); });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _a.sent();
                    console.error('Failed to delete project:', err_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleEditProject = function (project) {
        setEditingProject(project);
        setShowProjectModal(true);
    };
    var handleUpdateInvoice = function (invoiceId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateInvoice(invoiceId, data)];
                case 1:
                    _a.sent();
                    setInvoices(function (prev) {
                        return prev.map(function (inv) {
                            return inv.id === invoiceId
                                ? __assign(__assign({}, inv), { number: data.number, amount: data.amount, status: data.status, date: data.date, dueDate: data.due_date }) : inv;
                        });
                    });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    return [3 /*break*/, 3];
                case 2:
                    err_7 = _a.sent();
                    console.error('Failed to update invoice:', err_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteInvoice = function (invoiceId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteInvoice(invoiceId)];
                case 1:
                    _a.sent();
                    setInvoices(function (prev) { return prev.filter(function (inv) { return inv.id !== invoiceId; }); });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    return [3 /*break*/, 3];
                case 2:
                    err_8 = _a.sent();
                    console.error('Failed to delete invoice:', err_8);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleEditInvoice = function (invoice) {
        setEditingInvoice(invoice);
        setShowInvoiceModal(true);
    };
    var handleCreateInvoice = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var created_3, err_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createInvoice({
                            clientId: data.clientId,
                            number: data.number,
                            amount: data.amount,
                            status: data.status,
                            date: data.date,
                            dueDate: data.dueDate,
                        })];
                case 1:
                    created_3 = _a.sent();
                    setInvoices(function (prev) { return __spreadArray(__spreadArray([], prev, true), [created_3], false); });
                    onDataChanged === null || onDataChanged === void 0 ? void 0 : onDataChanged();
                    sendNotification({
                        type: 'invoice_created',
                        clientId: client.id,
                        invoiceNumber: data.number,
                        amount: data.amount.toLocaleString('ru-RU') + ' ₽',
                        dueDate: data.dueDate,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_9 = _a.sent();
                    console.error('Failed to create invoice:', err_9);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var nextInvoiceNumber = "INV-".concat(String(invoices.length + 1).padStart(3, '0'));
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.header, children: [_jsx("div", { className: styles.avatar, style: { background: client.color + '22', color: client.color }, children: client.avatar }), _jsxs("div", { className: styles.headerInfo, children: [_jsx("div", { className: styles.headerName, children: client.name }), _jsxs("div", { className: styles.headerMeta, children: [client.company, " \u00B7 ", client.email] })] }), onEditClient && (_jsx("button", { className: styles.editBtn, onClick: onEditClient, children: t.editClient })), _jsx("button", { className: styles.previewBtn, onClick: function () { return setShowPortal(true); }, children: t.previewPortal })] }), _jsx("div", { className: styles.tabs, children: TABS.map(function (t) { return (_jsxs("button", { className: "".concat(styles.tab, " ").concat(tab === t.key ? styles.tabActive : ''), onClick: function () { return setTab(t.key); }, children: [t.icon, " ", t.label, t.key === 'projects' && projects.length > 0 && (_jsx("span", { className: styles.tabCount, children: projects.length })), t.key === 'invoices' && invoices.length > 0 && (_jsx("span", { className: styles.tabCount, children: invoices.length })), t.key === 'files' && files.length > 0 && (_jsx("span", { className: styles.tabCount, children: files.length })), t.key === 'time' && (timerState === null || timerState === void 0 ? void 0 : timerState.timerRunning) && (_jsx("span", { className: styles.timerPulse }))] }, t.key)); }) }), tab === 'projects' && (_jsx(ProjectsTab, { projects: projects, onAdd: function () {
                    setEditingProject(null);
                    setShowProjectModal(true);
                }, onEdit: handleEditProject, onStatusChange: handleUpdateProject })), tab === 'invoices' && (_jsx(InvoicesTab, { invoices: invoices, onAdd: function () {
                    setEditingInvoice(null);
                    setShowInvoiceModal(true);
                }, onEdit: handleEditInvoice })), tab === 'files' && (_jsx(FilesTab, { files: files, onUpload: handleUploadFiles, onDownload: handleDownloadFile, onDelete: handleDeleteFile })), tab === 'time' && (_jsx(TimeTab, { projects: projects, clientId: client.id, onDataChanged: onDataChanged, timerRunning: (_b = timerState === null || timerState === void 0 ? void 0 : timerState.timerRunning) !== null && _b !== void 0 ? _b : false, timerSeconds: (_c = timerState === null || timerState === void 0 ? void 0 : timerState.timerSeconds) !== null && _c !== void 0 ? _c : 0, timerProjectId: (_d = timerState === null || timerState === void 0 ? void 0 : timerState.timerProjectId) !== null && _d !== void 0 ? _d : null, timerDesc: (_e = timerState === null || timerState === void 0 ? void 0 : timerState.timerDesc) !== null && _e !== void 0 ? _e : '', onTimerStart: (_f = timerState === null || timerState === void 0 ? void 0 : timerState.onTimerStart) !== null && _f !== void 0 ? _f : (function () { }), onTimerStop: (_g = timerState === null || timerState === void 0 ? void 0 : timerState.onTimerStop) !== null && _g !== void 0 ? _g : (function () { }), onTimerReset: (_h = timerState === null || timerState === void 0 ? void 0 : timerState.onTimerReset) !== null && _h !== void 0 ? _h : (function () { }), onTimerProjectChange: (_j = timerState === null || timerState === void 0 ? void 0 : timerState.onTimerProjectChange) !== null && _j !== void 0 ? _j : (function () { }), onTimerDescChange: (_k = timerState === null || timerState === void 0 ? void 0 : timerState.onTimerDescChange) !== null && _k !== void 0 ? _k : (function () { }) })), tab === 'portal' && (_jsx(PortalTab, { client: client, onPreview: function () { return setShowPortal(true); }, isPro: isPro, onUpgrade: onUpgrade })), showPortal && (_jsx(PortalPreview, { client: __assign(__assign({}, client), { projects: projects, invoices: invoices }), onClose: function () { return setShowPortal(false); }, isPro: isPro })), showProjectModal && (_jsx(ProjectModal, { clientId: client.id, project: editingProject, onClose: function () {
                    setShowProjectModal(false);
                    setEditingProject(null);
                }, onSubmit: handleCreateProject, onUpdate: handleUpdateProject, onDelete: handleDeleteProject })), showInvoiceModal && (_jsx(InvoiceModal, { clientId: client.id, nextNumber: nextInvoiceNumber, invoice: editingInvoice, onClose: function () {
                    setShowInvoiceModal(false);
                    setEditingInvoice(null);
                }, onSubmit: handleCreateInvoice, onUpdate: handleUpdateInvoice, onDelete: handleDeleteInvoice }))] }));
};
// ─── Projects (Kanban) ───────────────────────────────────────────────────
var ProjectsTab = function (_a) {
    var projects = _a.projects, onAdd = _a.onAdd, onEdit = _a.onEdit, onStatusChange = _a.onStatusChange;
    var t = useI18n().t;
    var statusLabels = { brief: t.statusBrief, in_progress: t.statusInProgress, review: t.statusReview, done: t.statusDone };
    var _b = useState(null), draggedId = _b[0], setDraggedId = _b[1];
    var _c = useState(null), dragOverCol = _c[0], setDragOverCol = _c[1];
    var handleDragStart = function (e, project) {
        setDraggedId(project.id);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(project.id));
    };
    var handleDragOver = function (e, col) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverCol(col);
    };
    var handleDragLeave = function () {
        setDragOverCol(null);
    };
    var handleDrop = function (e, targetStatus) {
        e.preventDefault();
        setDragOverCol(null);
        setDraggedId(null);
        var projectId = parseInt(e.dataTransfer.getData('text/plain'), 10);
        var project = projects.find(function (p) { return p.id === projectId; });
        if (!project || project.status === targetStatus)
            return;
        // Drag-and-drop only changes status, never touches progress
        // Progress is managed by tasks (auto) or manually in modal
        onStatusChange(projectId, {
            name: project.name,
            status: targetStatus,
            progress: project.progress,
            deadline: project.deadline,
        });
    };
    var handleDragEnd = function () {
        setDraggedId(null);
        setDragOverCol(null);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.sectionHead, children: [_jsxs("div", { className: styles.sectionTitle, children: [t.tabProjects, projects.length === 0 && (_jsxs("span", { className: styles.emptyHint, children: [" ", t.noProjects] }))] }), _jsx("button", { className: styles.addBtn, onClick: onAdd, children: t.addProject })] }), _jsx("div", { className: styles.kanban, children: KANBAN_COLS.map(function (col) {
                    var s = STATUS_MAP[col];
                    var items = projects.filter(function (p) { return p.status === col; });
                    var isOver = dragOverCol === col;
                    return (_jsxs("div", { className: "".concat(styles.kanbanCol, " ").concat(isOver ? styles.kanbanColDragOver : ''), onDragOver: function (e) { return handleDragOver(e, col); }, onDragLeave: handleDragLeave, onDrop: function (e) { return handleDrop(e, col); }, children: [_jsxs("div", { className: styles.kanbanColTitle, style: { color: s.color }, children: [_jsx("span", { className: styles.kanbanDot, style: { background: s.color } }), statusLabels[col] || s.label, " (", items.length, ")"] }), items.map(function (p) { return (_jsxs("div", { className: "".concat(styles.kanbanCard, " ").concat(draggedId === p.id ? styles.kanbanCardDragging : '', " ").concat(p.priority === 'urgent' ? styles.kanbanCardUrgent : ''), onClick: function () { return onEdit(p); }, draggable: true, onDragStart: function (e) { return handleDragStart(e, p); }, onDragEnd: handleDragEnd, children: [_jsxs("div", { className: styles.kanbanCardTop, children: [_jsx("div", { className: styles.kanbanCardName, children: p.name }), p.priority === 'urgent' && (_jsx("span", { className: styles.urgentBadge, children: "\uD83D\uDD25" }))] }), _jsxs("div", { className: styles.progressRow, children: [_jsx("div", { className: styles.progressBar, children: _jsx("div", { className: styles.progressFill, style: { width: p.progress + '%', background: s.color } }) }), _jsxs("span", { className: styles.progressLabel, children: [p.progress, "%"] })] }), p.deadline && (_jsxs("div", { className: styles.kanbanDeadline, children: [t.deadline, ": ", formatDate(p.deadline)] }))] }, p.id)); }), items.length === 0 && !isOver && (_jsx("div", { className: styles.kanbanEmpty, children: t.empty })), isOver && (_jsx("div", { className: styles.kanbanDropHint, children: t.dropHere }))] }, col));
                }) })] }));
};
// ─── Invoices ────────────────────────────────────────────────────────────
var InvoicesTab = function (_a) {
    var invoices = _a.invoices, onAdd = _a.onAdd, onEdit = _a.onEdit;
    var t = useI18n().t;
    var invStatusLabels = { paid: t.invoiceStatusPaid, pending: t.invoiceStatusPending, overdue: t.invoiceStatusOverdue };
    var total = invoices.reduce(function (s, i) { return s + i.amount; }, 0);
    var paid = invoices.filter(function (i) { return i.status === 'paid'; }).reduce(function (s, i) { return s + i.amount; }, 0);
    var pending = invoices.filter(function (i) { return i.status !== 'paid'; }).reduce(function (s, i) { return s + i.amount; }, 0);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.sectionHead, children: [_jsx("div", { className: styles.sectionTitle, children: t.tabInvoices }), _jsx("button", { className: styles.addBtn, onClick: onAdd, children: t.newInvoice })] }), invoices.length > 0 && (_jsxs("div", { className: styles.invoiceStats, children: [_jsxs("div", { className: styles.invoiceStat, children: [_jsx("span", { className: styles.invoiceStatLabel, children: t.totalAmount }), _jsx("span", { className: styles.invoiceStatValue, children: formatMoney(total) })] }), _jsxs("div", { className: styles.invoiceStat, children: [_jsx("span", { className: styles.invoiceStatLabel, children: t.paidAmount }), _jsx("span", { className: styles.invoiceStatValueGreen, children: formatMoney(paid) })] }), _jsxs("div", { className: styles.invoiceStat, children: [_jsx("span", { className: styles.invoiceStatLabel, children: t.pendingAmount }), _jsx("span", { className: styles.invoiceStatValueYellow, children: formatMoney(pending) })] })] })), invoices.length === 0 ? (_jsx("div", { className: styles.empty, children: t.noInvoices })) : (_jsx("div", { className: styles.tableWrapper, children: _jsxs("table", { className: styles.table, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: t.invoiceNumber }), _jsx("th", { children: t.invoiceAmount }), _jsx("th", { children: t.invoiceDate }), _jsx("th", { children: t.invoiceDueDate }), _jsx("th", { children: t.invoiceStatus })] }) }), _jsx("tbody", { children: invoices.map(function (inv) {
                                var s = INVOICE_STATUS_MAP[inv.status];
                                return (_jsxs("tr", { onClick: function () { return onEdit(inv); }, style: { cursor: 'pointer' }, children: [_jsx("td", { className: styles.bold, children: inv.number }), _jsx("td", { className: styles.amount, children: formatMoney(inv.amount) }), _jsx("td", { className: styles.muted, children: formatDate(inv.date) }), _jsx("td", { className: styles.muted, children: inv.dueDate ? formatDate(inv.dueDate) : '—' }), _jsx("td", { children: _jsxs("span", { className: styles.badge, style: { color: s.color, background: s.bg }, children: ["\u25CF ", invStatusLabels[inv.status] || s.label] }) })] }, inv.id));
                            }) })] }) }))] }));
};
// ─── Files ───────────────────────────────────────────────────────────────
var FilesTab = function (_a) {
    var files = _a.files, onUpload = _a.onUpload, onDownload = _a.onDownload, onDelete = _a.onDelete;
    var _b = useI18n(), t = _b.t, locale = _b.locale;
    var fileInputRef = useRef(null);
    var _c = useState(false), uploading = _c[0], setUploading = _c[1];
    var _d = useState(null), deleteConfirmId = _d[0], setDeleteConfirmId = _d[1];
    var handleFileChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.target.files && e.target.files.length > 0)) return [3 /*break*/, 2];
                    setUploading(true);
                    return [4 /*yield*/, onUpload(e.target.files)];
                case 1:
                    _a.sent();
                    setUploading(false);
                    if (fileInputRef.current)
                        fileInputRef.current.value = '';
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var uploadLabel = uploading ? (locale === 'ru' ? '⏳ Загрузка...' : '⏳ Uploading...') : (locale === 'ru' ? '+ Загрузить файл' : '+ Upload File');
    var noFilesHint = locale === 'ru' ? 'Загрузите файлы для клиента — они будут доступны в портале' : 'Upload files for your client — they will be available in the portal';
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.sectionHead, children: [_jsx("div", { className: styles.sectionTitle, children: t.tabFiles }), _jsx("button", { className: styles.addBtn, onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: uploading, children: uploadLabel }), _jsx("input", { ref: fileInputRef, type: "file", multiple: true, style: { display: 'none' }, onChange: handleFileChange })] }), files.length === 0 ? (_jsxs("div", { className: styles.emptyFiles, children: [_jsx("div", { className: styles.emptyIcon, children: "\uD83D\uDCC1" }), _jsx("div", { className: styles.emptyText, children: t.noFiles }), _jsx("div", { className: styles.emptyHint, children: noFilesHint })] })) : (_jsx("div", { className: styles.tableWrapper, children: files.map(function (f) { return (_jsxs("div", { className: styles.fileRow, children: [_jsx("span", { className: styles.fileIcon, children: FILE_ICONS[f.type] || '📄' }), _jsxs("div", { className: styles.fileInfo, children: [_jsx("div", { className: styles.fileName, children: f.name }), _jsxs("div", { className: styles.fileMeta, children: [f.size, " \u00B7 ", formatDate(f.date)] })] }), deleteConfirmId === f.id ? (_jsxs("div", { className: styles.fileActions, children: [_jsx("button", { className: styles.fileDeleteConfirm, onClick: function () { onDelete(f); setDeleteConfirmId(null); }, children: t.delete }), _jsx("button", { className: styles.fileCancelBtn, onClick: function () { return setDeleteConfirmId(null); }, children: t.no })] })) : (_jsxs("div", { className: styles.fileActions, children: [_jsxs("button", { className: styles.downloadBtn, onClick: function () { return onDownload(f); }, children: ["\u2B07 ", t.download] }), _jsx("button", { className: styles.fileDeleteBtn, onClick: function () { return setDeleteConfirmId(f.id); }, children: "\uD83D\uDDD1" })] }))] }, f.id)); }) }))] }));
};
// ─── Portal settings ────────────────────────────────────────────────────
var PortalTab = function (_a) {
    var client = _a.client, onPreview = _a.onPreview, _b = _a.isPro, isPro = _b === void 0 ? false : _b, onUpgrade = _a.onUpgrade;
    var _c = useI18n(), t = _c.t, locale = _c.locale;
    var _d = useState(null), portalToken = _d[0], setPortalToken = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(false), copied = _f[0], setCopied = _f[1];
    var portalUrl = portalToken
        ? "".concat(window.location.origin, "/portal/").concat(portalToken)
        : null;
    var handleActivate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, err_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getOrCreatePortalToken(client.id)];
                case 2:
                    token = _a.sent();
                    setPortalToken(token);
                    return [3 /*break*/, 4];
                case 3:
                    err_10 = _a.sent();
                    console.error('Failed to create portal token:', err_10);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeactivate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deactivatePortalToken(client.id)];
                case 2:
                    _a.sent();
                    setPortalToken(null);
                    return [3 /*break*/, 4];
                case 3:
                    err_11 = _a.sent();
                    console.error('Failed to deactivate portal:', err_11);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCopy = function () {
        if (portalUrl) {
            navigator.clipboard.writeText(portalUrl);
            setCopied(true);
            setTimeout(function () { return setCopied(false); }, 2000);
        }
    };
    React.useEffect(function () {
        var loadToken = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, supabase
                                .from('portal_tokens')
                                .select('token')
                                .eq('client_id', client.id)
                                .eq('is_active', true)
                                .single()];
                    case 1:
                        data = (_b.sent()).data;
                        if (data)
                            setPortalToken(data.token);
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadToken();
    }, [client.id]);
    return (_jsxs("div", { children: [_jsxs("div", { className: styles.portalLinkCard, children: [_jsx("div", { className: styles.portalLinkLabel, children: t.portalLink }), portalUrl ? (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.portalLinkRow, children: [_jsx("div", { className: styles.portalLinkValue, children: portalUrl }), _jsx("button", { className: styles.copyBtn, onClick: handleCopy, children: copied ? "\u2705 ".concat(t.copied) : "\uD83D\uDCCB ".concat(t.copyLink) })] }), _jsxs("div", { className: styles.portalActiveRow, children: [_jsxs("span", { className: styles.portalActiveLabel, children: ["\u25CF ", locale === 'ru' ? 'Портал активен' : 'Portal active'] }), _jsx("button", { className: styles.deactivateBtn, onClick: handleDeactivate, disabled: loading, children: t.deactivateLink })] })] })) : (_jsxs("div", { className: styles.portalInactive, children: [_jsx("div", { className: styles.portalInactiveText, children: locale === 'ru'
                                    ? 'Портал не активирован. Нажмите чтобы создать ссылку для клиента.'
                                    : 'Portal is not active. Click to generate a link for your client.' }), _jsx("button", { className: styles.activateBtn, onClick: handleActivate, disabled: loading, children: loading ? t.creating : "\uD83D\uDD17 ".concat(t.generateLink) })] }))] }), _jsx(BrandingSettings, { isPro: isPro, onUpgrade: onUpgrade }), _jsx(NotificationSettings, { clientId: client.id, clientEmail: client.email }), _jsx("div", { className: styles.portalActions, children: _jsx("button", { className: styles.previewBtnPrimary, onClick: onPreview, children: t.previewPortal }) })] }));
};
